import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { IDeviceChannel } from 'lavva.exalushome/build/js/Services/Devices/IDeviceChannel';
import { LightThresholdStateEnum } from 'lavva.exalushome/build/js/Services/Devices/IDeviceState';
import { IconToastWarning2 } from '../../../../../../../assets/toast-icons/icon-toast-warning-2';
import { useBrightnessControl } from '../../../hooks/use-brightness-control';
import { SensorControlBox } from '../../../../../../../components/sensor-control-box';

type MeasuredBrightnessControlProps = {
  channel: IDeviceChannel;
  isListItem?: boolean;
  details?: boolean;
};

const MeasuredBrightnessControl: React.FC<MeasuredBrightnessControlProps> = ({ channel, isListItem, details }) => {
  const { t } = useTranslation('channel-details');
  const { brightness, brightnessThreshold } = useBrightnessControl(channel);

  if (details || brightnessThreshold !== LightThresholdStateEnum.Exceeded) {
    return <SensorControlBox isListItem={isListItem} value={brightness} unit={'lx'} />;
  }

  return (
    <div
      className={classNames('list-controls', {
        'list-controls--list-item': isListItem,
      })}
    >
      <SensorControlBox isListItem={isListItem} value={brightness} unit={'lx'} />
      <div className="device-box__warning device-box__warning--no-padding">
        <IconToastWarning2 size={16} colorError />
        <span className={'m-l-8'}>{t('exalus.lightThresholdExceeded.heading')}</span>
      </div>
    </div>
  );
};

export default MeasuredBrightnessControl;
